module.exports = __webpack_public_path__ + "static/media/forgot.a35b9cc1.jpg";